import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { SongCard } from '@components/basics/SongCard';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { FragmentType, PlaylistInput } from '@graphql/reactQuery';
import { getFragment, ReleasesCardFragmentDoc } from '@graphql/reactQuery';
import { ReleaseCardActions } from './ReleaseCardActions';
import { useReleaseCardInfo } from './useReleaseCardInfo';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleasesCard on Release {
    id
    ...ReleaseCardActions
    ...ReleasesCardInfo
  }
`);

export const ReleaseCard = ({
  data,
  playlist,
}: {
  data: FragmentType<ReleasesCardFragmentDoc>;
  playlist: PlaylistInput;
}) => {
  const release = getFragment(ReleasesCardFragmentDoc, data);
  const {
    coverImageUrl,
    trackUrl,
    onPlayClick,
    isAudioBuffering: isBufferingAudio,
    playButtonPrefetchRef,
    isActiveTrack,
    isAlbum,
    hasAudioAccess,
    artistName,
    artistWebappPath,
    releaseTitle,
    currentListeningParty,
  } = useReleaseCardInfo({ data: release, playlist });

  return (
    <SongCard
      album={isAlbum}
      isPlaying={isActiveTrack}
      loading={false}
      edition={false}
      expanded={null}
      setExpanded={null}
    >
      <SongCard.Cover
        coverLink={trackUrl}
        image={<SongCard.Cover.Single src={coverImageUrl} />}
        onPlayButtonClick={onPlayClick}
        isBufferingSong={isBufferingAudio}
        disablePlay={!hasAudioAccess}
        playButtonPrefetchRef={playButtonPrefetchRef}
        currentListeningParty={currentListeningParty}
      />
      <SongCard.Info
        header={
          <AccessibleLink absoluteUri={trackUrl} type="external">
            {releaseTitle}
          </AccessibleLink>
        }
        subheader={<AccessibleLink pathnameUri={artistWebappPath}>{artistName}</AccessibleLink>}
        actions={<ReleaseCardActions data={release} />}
      />
    </SongCard>
  );
};
